import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { environment } from 'src/environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
const TOKEN_HEADER_KEY = 'Authorization';
const deviceTimeZone = new Date()
  .toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'long' })
  .substring(4);

const baseURL = environment.baseAPIUrl;
const authURL = environment.authAPIURL;
const uadLogin = environment.uadLogin;
@Injectable({
  providedIn: 'root'
})
export class RestService {
  orgGroupId: any;
  domain: any;
  UADOrgAppId: any;
  constructor(public http: HttpClient, private token: TokenStorageService) {
    this.domain = window.location.href;
    this.UADOrgAppId = environment.orgAppId;
  }

  postData<T>(data: T, url: string, headers?: any): Observable<any> {
    let webAPIRequest={
      orgAppID:environment.orgAppId.toString(),
      orgGroupID:this.getOrgGroupId(),
      source :'web'
    }
    let options = {
      headers: new HttpHeaders({
        //'fingerprint': `"RFzuSZGSmX0cpYW8PAJb", `, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        webAPIRequest:JSON.stringify(webAPIRequest)
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }


          return response;
        })
      );
    } else {
      return this.http.post<any>(`${baseURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postDataDs<T>(data: T, url: string, headers?: any): Observable<any> {
    let orgGroupId = this.getOrgGroupId();
    let options = {
      headers: new HttpHeaders({
        //'fingerprint': `"RFzuSZGSmX0cpYW8PAJb", `, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: environment.orgAppId.toString(),
        ...(orgGroupId ? { orgGroupId: orgGroupId } : {})
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }


          return response;
        })
      );
    } else {
      return this.http.post<any>(`${authURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postUATData<T>(data: T, url: string, headers?: any): Observable<any> {
    let orgGroupId = this.getOrgGroupId();
    let options = {
      headers: new HttpHeaders({
        //'fingerprint': `"RFzuSZGSmX0cpYW8PAJb", `, //-> This is not required -> Commented by Abirami on March 30th
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: environment.orgAppId.toString(),
        ...(orgGroupId ? { orgGroupId: orgGroupId } : {})
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${authURL}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  postUADLogin<T>(data: T, url: string, headers?: any): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        fingerprint: `"RFzuSZGSmX0cpYW8PAJb", `,
        // "clientInfo": ` {"deviceID":"RFzuSZGSmX0cpYW8PAJb","deviceID2":"RFzuSZGSmX0cpYW8PAJb","deviceTimeZone":"India Standard Time","deviceIpAddress":"103.82.210.58","deviceLatitude":12.686,"deviceLongitude":77.8637,"deviceType":"desktop","deviceModel":"Windows","deviceVersion":"windows-10","deviceUserID":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36 Edg/113.0.1774.35","deviceAppVersion":"1.0.8","deviceIsJailBroken":false,"language":"en"}`,
        // "Authorization": `Bearer  ${x}`,
        orgAppID: this.UADOrgAppId.toString(),
      }),
    };
    if (url.startsWith('https://')) {
      return this.http.post<any>(url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    } else {
      return this.http.post<any>(`${uadLogin}` + url, data, options).pipe(
        map((response) => {
          if (response.rcode == 500) {
            return null;
          }
          return response;
        })
      );
    }
  }
  fetchData<T>(
    graphqlPayload: T,
    url: string,
    additionalheaders: any
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        Reportid: additionalheaders.reportID.toLowerCase(),
        Filters: JSON.stringify(additionalheaders.filters),
        'Content-Type': 'application/json',
      }),
    };
    return this.http
      .post<any>(`${baseURL}${url}`, graphqlPayload, options)
      .pipe(
        map((response) => {
          // Your additional processing logic goes here
          return response;
        })
      );
  }
  fetchDataUAD<T>(
    graphqlPayload: T,
    url: string,
    additionalheaders: any
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        Reportid: additionalheaders.reportID.toLowerCase(),
        Filters: JSON.stringify(additionalheaders.filters),
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .post<any>(`${authURL}${url}`, graphqlPayload, options)
      .pipe(
        map((response) => {
          // Your additional processing logic goes here
          return response;
        })
      );
  }

  getData<T>(url: string, isFullURL?: boolean): Observable<T> {
    return this.http.get<T>(isFullURL ? `${url}` : `${baseURL}${url}`);
  }
  getDataMethod<T>(url: string, params?: HttpParams): Observable<any> {
    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return response;
      })
    );
  }
  public getPhoneCode(): Observable<any> {
    return this.http.get('./assets/jsons/phoneCode.json');
  }
  public getComparsionJson(): Observable<any> {
    return this.http.get('./assets/comparsion.json');
  }
  getOrgGroupId(): string | null {
    if (this.domain.includes('starhealth-primez.insure.digital')) {
      return 'FDB0084B-42E5-4068-BA55-A2974CCC148B';
    } else if (this.domain.includes('zuno-primez.insure.digital')) {
      return '1617FE0B-2702-4326-848F-C29FD36C5536';
    } else if (this.domain.includes('cholams-primez.insure.digital')) {
      return '77FA6E18-1AD1-4F90-BE14-CA03EE14ABE7';
    } else if (this.domain.includes('nyala-primez.insure.digital') ||
               this.domain.includes('uat-core-primez.insure.digital') ||
               this.domain.includes('development-pc-primez.insure.digital')) {
      return '880E93D0-7D9D-478E-8EAC-6FF9D3C71F1E';
    } else if (this.domain.includes('zambia-primez.insure.digital')) {
      return '9EE3DB12-706C-4A8A-9B30-F3D591881048';
    }else if (this.domain.includes('kenindia-travel.insure.digital')) {
      return 'e6177150-0a4b-46f1-9c27-b55e848a69eb';
    }
    return 'e6177150-0a4b-46f1-9c27-b55e848a69eb';
  }
  

}
